export interface PasswordRule {
	id: "length" | "lowercase" | "uppercase" | "number" | "special";
	label: string;
	test: (password: string) => boolean;
}

// Same rule as services/signup (domain/trial-signup.ts passwordProblem).
export const PASSWORD_RULES: readonly PasswordRule[] = [
	{ id: "length", label: "8 to 100 characters", test: p => p.length >= 8 && p.length <= 100 },
	{ id: "lowercase", label: "One lowercase letter", test: p => /[a-z]/.test(p) },
	{ id: "uppercase", label: "One capital letter", test: p => /[A-Z]/.test(p) },
	{ id: "number", label: "One number", test: p => /[0-9]/.test(p) },
	{ id: "special", label: "One special character", test: p => /[^A-Za-z0-9]/.test(p) },
];

export function passwordValid(password: string): boolean {
	return PASSWORD_RULES.every(rule => rule.test(password));
}

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
